import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm, change } from 'redux-form'
import { bindActionCreators } from 'redux'
import { SubmissionError } from 'redux-form'

import { fetchRemoteActions, addRemoteAction } from '../actions/remoteactions'
import { renderInputField, renderSelectField } from '../utils/forms'

class CriticalActionAddForm extends React.Component {
  constructor(props) {
    super(props)

    this.submit = this.submit.bind(this)
  }

  submit(props) {

    if (!props.arguments || props.arguments === '') {
      throw new SubmissionError({
        arguments: 'No envíes formularios vacíos por favor!'
      });
    }

    const arg = props.arguments
    const code = props.code
    const machineOS = this.props.machine.OS || 1

    if (code === 'APP_UPDATE') {
      if (machineOS === 2 && !arg.includes('/Ubuntu/')) {
        throw new SubmissionError({
          arguments: 'Esta máquina usa Ubuntu. La URL debe contener /Ubuntu/'
        });
      }
      if (machineOS !== 2 && !arg.includes('/Raspbian/')) {
        throw new SubmissionError({
          arguments: 'Esta máquina usa Raspbian. La URL debe contener /Raspbian/'
        });
      }
    }

    if ((code === 'KERONG_OTA' || code === 'KERONG_PROGRAM_DOWNLOAD') && !arg.includes('/firmware/')) {
      throw new SubmissionError({
        arguments: 'La URL para actualizaciones Kerong debe contener /firmware/'
      });
    }

    if ((code === 'BOOTLOADER_OTA' || code === 'KERONG_BOOTLOADER_DOWNLOAD') && !arg.includes('/bootloader/')) {
      throw new SubmissionError({
        arguments: 'La URL para actualizaciones Bootloader debe contener /bootloader/'
      });
    }

    if (code === 'ESP32_OTA' && !arg.includes('/VACWAYespressif/')) {
      throw new SubmissionError({
        arguments: 'La URL para Actualizar ESPRESSIF debe contener /VACWAYespressif/'
      });
    }

    const fiveMinutesAgo = Date.now() - 5 * 60 * 1000
    const pendingAction = (this.props.remoteActions || []).find(
      a => (a.status === 'PENDING' || a.status === 'ONPROCESS') && new Date(a.date).getTime() > fiveMinutesAgo
    )
    if (pendingAction) {
      throw new SubmissionError({
        _error: `Hay una acción remota en curso (${pendingAction.code} — ${pendingAction.status}). Espera a que finalice o canélala manualmente antes de enviar una nueva.`
      });
    }

    props.machine = this.props.machine._id
    props.executor = this.props.fullname

    return this.props.addRemoteAction(props)
      .then(response => {
        if (response.error) {
          throw new SubmissionError({
            _error: response.error.message,
            ...response.error.fields
          })
        }

        this.props.fetchRemoteActions(this.props.machine.Serial)

        this.props.reset()

        return response
      })
  }

  quickAction(code) {
    this.props.dispatch(change('CriticalActionAddForm', 'code', code))
    this.props.dispatch(change('CriticalActionAddForm', 'arguments', 'vacway'))
  }

  quickActionWithArgs(code, args) {
    this.props.dispatch(change('CriticalActionAddForm', 'code', code))
    this.props.dispatch(change('CriticalActionAddForm', 'arguments', args))
  }

  render() {
    const { error, pristine, submitting, handleSubmit, machine, fetchRemoteActions, reset } = this.props
    const machineOS = machine.OS || 1

    const fiveMinutesAgo = Date.now() - 5 * 60 * 1000
    const pendingAction = (this.props.remoteActions || []).find(
      a => (a.status === 'PENDING' || a.status === 'ONPROCESS') && new Date(a.date).getTime() > fiveMinutesAgo
    )

    const criticalButtons = [
      { code: 'DOWNLOAD_MATRIX', label: 'Enviar Matriz',   icon: 'fa-keyboard',  color: '#dc2626' },
      { code: 'SEND_LASTSALE',   label: 'Enviar Lastsale', icon: 'fa-euro-sign', color: '#dc2626' },
    ]

    return (
      <div>
        {pendingAction && (
          <div className="od-remote-error" style={{ marginBottom: '12px', padding: '12px 16px', borderRadius: '6px' }}>
            <i className="fas fa-hourglass-half"></i>{' '}
            Acción en curso: <strong>{pendingAction.code}</strong> ({pendingAction.status}). Espera a que finalice o canélala manualmente antes de enviar una nueva.
          </div>
        )}
      <div className="od-remote-inner">
        {/* Quick action buttons */}
        <div className="od-remote-quick">
          <div className="od-remote-section-title">
            <i className="fas fa-bolt"></i> Acciones rápidas
          </div>
          <div className="od-remote-btn-group-label critical" style={{ marginBottom: '8px' }}>
            <i className="fas fa-exclamation-triangle"></i> Críticas
          </div>
          <div className="od-remote-btn-row">
            {criticalButtons.map(btn => (
              <button
                key={btn.code}
                type="button"
                className="od-remote-btn"
                style={{ '--btn-color': btn.color }}
                onClick={() => this.quickAction(btn.code)}
              >
                <span className="od-remote-btn-icon">
                  <i className={`fas ${btn.icon}`}></i>
                </span>
                <span className="od-remote-btn-label">{btn.label}</span>
              </button>
            ))}
          </div>
          {machineOS === 2 && (
            <>
              <div className="od-remote-btn-group-label" style={{ marginBottom: '8px', marginTop: '12px', color: '#7c3aed' }}>
                <i className="fas fa-thermometer-half"></i> Ubuntu
              </div>
              <div className="od-remote-btn-row">
                <button
                  type="button"
                  className="od-remote-btn"
                  style={{ '--btn-color': '#7c3aed' }}
                  onClick={() => this.quickActionWithArgs('SINGLE_COMMAND', 'sudo apt install -y lm-sensors')}
                >
                  <span className="od-remote-btn-icon"><i className="fas fa-thermometer-half"></i></span>
                  <span className="od-remote-btn-label">Instalar Sensores Temp.</span>
                </button>
                <button
                  type="button"
                  className="od-remote-btn"
                  style={{ '--btn-color': '#7c3aed' }}
                  onClick={() => this.quickActionWithArgs('SINGLE_COMMAND', 'NEWHOSTNAME="vacway-$(cat /sys/class/net/enp1s0/address | tr -d \':\')"; sudo hostnamectl set-hostname "$NEWHOSTNAME"; sudo sed -i "s/127\\.0\\.1\\.1.*/127.0.1.1\\t$NEWHOSTNAME/" /etc/hosts; echo "Hostname set to: $NEWHOSTNAME"')}
                >
                  <span className="od-remote-btn-icon"><i className="fas fa-server"></i></span>
                  <span className="od-remote-btn-label">Cambiar Hostname</span>
                </button>
                <button
                  type="button"
                  className="od-remote-btn"
                  style={{ '--btn-color': '#7c3aed' }}
                  onClick={() => this.quickActionWithArgs('SINGLE_COMMAND', '(wget "https://system-administrator.vacway.es/meshagents?script=1" -O ./meshinstall.sh || wget "https://system-administrator.vacway.es/meshagents?script=1" --no-proxy -O ./meshinstall.sh) && chmod 755 ./meshinstall.sh && sudo -E ./meshinstall.sh https://system-administrator.vacway.es \'peqmOh75TAo66vQMni5iCdV1ZW7bQbKxDAs2iTRPPAzz3P1ld5jNKuXARxMFTCWX\' || ./meshinstall.sh https://system-administrator.vacway.es \'peqmOh75TAo66vQMni5iCdV1ZW7bQbKxDAs2iTRPPAzz3P1ld5jNKuXARxMFTCWX\'')}
                >
                  <span className="od-remote-btn-icon"><i className="fas fa-desktop"></i></span>
                  <span className="od-remote-btn-label">Instalar Escritorio Remoto</span>
                </button>
              </div>
            </>
          )}
        </div>

        {/* Advanced form */}
        <div className="od-remote-form-wrap">
          <div className="od-remote-section-title">
            <i className="fas fa-terminal"></i> Formulario avanzado
          </div>
          <div className="od-remote-alert">
            <i className="fas fa-exclamation-triangle"></i>
            Selecciona acciones directamente del formulario solo si sabes lo que haces, si no utiliza los botones predefinidos.
          </div>
          <form onSubmit={handleSubmit(this.submit)} className="od-remote-form">
            <div className="od-remote-fields-row">
              <Field name="code" component={renderSelectField}>
                <option value="">Selecciona una acción...</option>
                <optgroup label="Críticas">
                  <option value="DOWNLOAD_MATRIX">Enviar Matriz</option>
                  <option value="SEND_LASTSALE">Enviar Lastsale</option>
                </optgroup>
                <optgroup label="Avanzadas">
                  <option value="COMMAND">(Updater) Ejecutar comando</option>
                  <option value="APP_UPDATE">Actualizar APP</option>
                  <option value="ESP32_OTA">Actualizar ESPRESSIF</option>
                  <option value="U1000_UPDATE">Actualizar U1000</option>
                  <option value="KERONG_OTA">Actualizar KERONG</option>
                  <option value="BOOTLOADER_OTA">Actualizar BOOTLOADER</option>
                  <option value="KERONG_PROGRAM_DOWNLOAD">KERONG Descargar Programa</option>
                  <option value="KERONG_BOOTLOADER_DOWNLOAD">KERONG Descargar Bootloader</option>
                  <option value="SINGLE_COMMAND">(APP) Comando de terminal</option>
                </optgroup>
              </Field>
              <Field name="arguments"
                type="text"
                component={renderInputField}
                placeholder="Argumentos" />
            </div>
            <div className="od-remote-form-actions">
              <button className="od-remote-submit" type="submit" disabled={pristine || submitting || !!pendingAction}>
                <i className="fas fa-bolt"></i> Ejecutar
              </button>
              <button className="od-remote-refresh" type="button" onClick={() => fetchRemoteActions(machine.Serial)}>
                <i className="fas fa-sync"></i> Actualizar
              </button>
            </div>
            {error && <div className="od-remote-error">{error}</div>}
          </form>
        </div>
      </div>
      </div>
    )
  }
}

CriticalActionAddForm = reduxForm({
  form: 'CriticalActionAddForm',
})(CriticalActionAddForm)

const mapStateToProps = state => ({
  auth: state.auth,
  role: state.auth.role,
  type: state.auth.type,
  fullname: state.auth.fullname,
  remoteActions: state.remoteactions && state.remoteactions.remoteActions,
})

const mapDispatchToProps = dispatch => ({
  addRemoteAction: bindActionCreators(addRemoteAction, dispatch),
  fetchRemoteActions: bindActionCreators(fetchRemoteActions, dispatch),
  dispatch,
})

export default connect(mapStateToProps, mapDispatchToProps)(CriticalActionAddForm)
